import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthenticationHelperService} from '../services/helpers/authentication-helper.service';
import {DEFAULT_AUTHENTICATED_PAGE, PAGES_AND_PATHS} from '../constants/pages-and-paths';

@Injectable()
export class PublicListGuardService {

  constructor(public authenticationService: AuthenticationHelperService,
              private router: Router, private authHelperService: AuthenticationHelperService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isUserAuth = this.authHelperService.isAuthenticated;
    const id = route.params.id;

    if (isUserAuth) {
      // Redirect to the private page (single-list/:id/cards) if authenticated
      this.router.navigate(['/single-list', id, 'cards']);
      return false; // Prevent access to the public page
    }

    // Allow access to the public page if not authenticated
    return true;
  }
}
